var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "transaction_footer"
  }, [_c('a', {
    staticClass: "repeat",
    attrs: {
      "title": "Повторить"
    },
    on: {
      "click": _vm.onRepeatPayment
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.repeat')) + " ")]), _c('a', {
    staticClass: "code",
    attrs: {
      "title": _vm.$t('get.qr.code')
    },
    on: {
      "click": _vm.onFetchQRCode
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('get.qr.code')) + " ")]), _c('a', {
    staticClass: "share",
    attrs: {
      "title": _vm.$t('to.share')
    },
    on: {
      "click": _vm.onShareBill
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('to.share')) + " ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }